import React from "react";
import Badge from "./Badge.jsx";

// 분실물 카드 컴포넌트
const ItemCard = ({ item, onClick }) => {
  // 상태가 완료이면 '주인찾음' 배지 표시
  const badgeType = item.status === '완료' ? '주인찾음' : item.item_type;

  return (
    <div className="item-card" onClick={onClick}>
      {/* 카드 상단 */}
      <div className="card-header">
        <h3 className="card-title">{item.title}</h3>

        {/* 상태 배지 */}
        <Badge type={badgeType} />
      </div>

      {/* 분실물 정보 */}
      <div className="card-info">
        <p>장소: {item.location}</p>
        <p>날짜: {item.item_date}</p>
      </div>
    </div>
  );
};

export default ItemCard;